var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectionField',{attrs:{"hasError":_vm.hasError,"disabled":_vm.disabled,"value":_vm.item,"items":_vm.items},on:{"change":_vm.valueChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }